import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest, transfersFromCached } from '../../lib/common'

import * as Constants from './constants'
import * as brActions from './actions'
const getRoleState = state => state.role;

function listRequestApi (formData) {
  const request = axiosApi().post(
    Constants.ROLE_LIST_API, 
    formData
  )

  return handleRequest(request);
}

function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.ROLE_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}

function roleUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.ROLE_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* roleListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.roleListSuccess(results.data))

  } catch (error) {
    yield put(brActions.roleListError(error))
  }
}

function* roleDetailRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.roleDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.roleDetailError(error))
  }
}
function menuRequestApi (formData) {
  const request = axiosApi().post(
    Constants.MENU_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function* menuListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const {data} = yield call(menuRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.menuListSuccess(data))

  } catch (error) {
    yield put(brActions.menuListError(error))
  }
}

function usersRequestApi (formData) {
  const request = axiosApi().post(
    Constants.USERS_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function* usersListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(usersRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.usersListSuccess(results.data))

  } catch (error) {
    yield put(brActions.usersListError(error))
  }
}

function* roleUpdateRequestFlow (action) {
  const role = yield select(getRoleState);
  try {
    // grab the client from our action
    const result = yield call(roleUpdateRequestApi, role.formData)

    // dispatch the action with our widgets!
    yield put(brActions.roleUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.roleUpdateError(error))
  }
}

function* roleWatcher () {
  yield [
    takeLatest(Constants.ROLE_LIST_REQUESTING, roleListRequestFlow),
    takeLatest(Constants.ROLE_DETAIL_REQUESTING, roleDetailRequestFlow),
    takeLatest(Constants.MENU_LIST_REQUESTING, menuListRequestFlow),
    takeLatest(Constants.USERS_LIST_REQUESTING, usersListRequestFlow),
    takeLatest(Constants.ROLE_UPDATE_REQUESTING, roleUpdateRequestFlow),
  ]
}

export default roleWatcher



// WEBPACK FOOTER //
// ./src/views/Role/sagas.js